<div class="rma-list-filters">
  <mat-form-field appearance="outline" class="no-bottom filter dense-minimum">
    <mat-label>Filter</mat-label>
    <input #filter [(ngModel)]="filterValue" matInput type="text">
    <button (click)="clearFilter()" aria-label="Clear" mat-icon-button matSuffix>
      @if (filterLoading) {
        <mat-spinner class="progress-spinner" diameter="24"></mat-spinner>
      } @else {
        <mat-icon [class.empty]="isFilterEmpty()">close</mat-icon>
      }
    </button>
  </mat-form-field>

  <!--<mat-button-toggle-group (change)="onStatusFilterChange()" [(ngModel)]="filterStatuses"
                           aria-label="Statuses" multiple name="status">
    <mat-button-toggle disabled>Status</mat-button-toggle>
    <mat-button-toggle *ngFor="let s of statuses" [value]="s">{{ s }}</mat-button-toggle>
  </mat-button-toggle-group>-->

  <mat-form-field appearance="outline" class="no-bottom ordering dense-minimum">
    <mat-label>Order by</mat-label>
    <mat-select (selectionChange)="onOrderChange()" [(value)]="order">
      <mat-option value="rmaNumber-desc">RMA Number ↓</mat-option>
      <mat-option value="rmaNumber-asc">RMA Number ↑</mat-option>
      <!--<mat-option value="created-desc">Created ↓</mat-option>
      <mat-option value="created-asc">Created ↑</mat-option>
      <mat-option value="timeSpent-desc">Time Spent ↓</mat-option>
      <mat-option value="timeSpent-asc">Time Spent ↑</mat-option>-->
    </mat-select>
  </mat-form-field>

  <button (click)="openCreateDialog()" color="primary" extended mat-fab>
    <mat-icon>add</mat-icon>
    New RMA
  </button>

  <span class="spacer"></span>

  <button [matMenuTriggerFor]="columnsMenu" mat-icon-button matTooltip="Show/hide columns">
    <mat-icon>more_vert</mat-icon>
  </button>

  <mat-menu #columnsMenu="matMenu">
    <strong mat-menu-item>Show/hide columns</strong>
    <div (click)="toggleColumnVisibility(c); $event.stopPropagation()" *ngFor="let c of columns" mat-menu-item>
      <mat-checkbox [checked]="c.visible">{{ c.label }}</mat-checkbox>
    </div>
    <button (click)="resetColumnVisibility()" mat-menu-item>
      <mat-icon>restart_alt</mat-icon>
      <span>Reset to defaults</span>
    </button>
  </mat-menu>
</div>

<div class="rma-list mat-elevation-z8">
  <table [dataSource]="dataSource" mat-table>

    <ng-container matColumnDef="rmaNumber">
      <th *matHeaderCellDef mat-header-cell>RMA Number</th>
      <td *matCellDef="let element" class="no-wrap" mat-cell>
        <a [routerLink]="element.rmaNumber">{{ element.rmaNumber }}</a>
        @if (alertsFor(element, alerts()); as a) {
          <mat-icon [matTooltip]="alertsTooltip(element, a)" class="small-icon" color="warn">priority_high</mat-icon>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="loaner">
      <th *matHeaderCellDef mat-header-cell>
        <div class="flex-row">
          <mat-icon class="small-icon" matTooltip="Substitutes were loaned.">sync_alt</mat-icon>
          <app-check-box-filter (change)="onLoanerFilterChange($event)"
                                [options]="loanerFilterOptions"
                                [selected]="loanerFilterSelected"></app-check-box-filter>
        </div>
      </th>
      <td *matCellDef="let element" mat-cell>
        <mat-icon *ngIf="element.loanedItems.length > 0" [matTooltip]="loanedItemTooltip(element)"
                  class="small-icon">
          sync_alt
        </mat-icon>
      </td>
    </ng-container>
    <ng-container matColumnDef="warranty">
      <th *matHeaderCellDef mat-header-cell>
        <div class="flex-row">
          <mat-icon class="small-icon material-symbols-outlined" matTooltip="Is under warranty">license</mat-icon>
          <app-check-box-filter (change)="onWarrantyFilterChange($event)"
                                [options]="warrantyFilterOptions"
                                [selected]="warrantyFilterSelected"></app-check-box-filter>
        </div>
      </th>
      <td *matCellDef="let element" mat-cell>
        <mat-icon *ngIf="element.isWarranty" class="small-icon material-symbols-outlined"
                  matTooltip="Is under warranty">license
        </mat-icon>
      </td>
    </ng-container>
    <ng-container matColumnDef="serialNumber">
      <th *matHeaderCellDef mat-header-cell>Serial Number</th>
      <td *matCellDef="let element" mat-cell> {{ element.serialNumber }}</td>
    </ng-container>
    <ng-container matColumnDef="manufacturer">
      <th *matHeaderCellDef mat-header-cell>Manufacturer</th>
      <td *matCellDef="let element" mat-cell> {{ element.manufacturer }}</td>
    </ng-container>
    <ng-container matColumnDef="sku">
      <th *matHeaderCellDef mat-header-cell>SKU</th>
      <td *matCellDef="let element" mat-cell> {{ element.sku }}</td>
    </ng-container>
    <ng-container matColumnDef="model">
      <th *matHeaderCellDef mat-header-cell>Model</th>
      <td *matCellDef="let element" mat-cell> {{ element.model }}</td>
    </ng-container>
    <ng-container matColumnDef="description">
      <th *matHeaderCellDef mat-header-cell>Problem Description</th>
      <td *matCellDef="let element" mat-cell> {{ element.description }}</td>
    </ng-container>
    <ng-container matColumnDef="clientName">
      <th *matHeaderCellDef mat-header-cell>Client Name</th>
      <td *matCellDef="let element" mat-cell>
        <a (click)="setFilter(element.clientName, $event)" class="client-filter">{{ element.clientName }}</a>
      </td>
    </ng-container>
    <ng-container matColumnDef="lastStatus">
      <th *matHeaderCellDef mat-header-cell>Last Status</th>
      <td *matCellDef="let element" class="no-wrap" mat-cell>
        <app-rma-status [rma]="element"></app-rma-status>
      </td>
    </ng-container>
    <ng-container matColumnDef="created">
      <th *matHeaderCellDef mat-header-cell>Created</th>
      <td *matCellDef="let element" mat-cell>
        <app-advanced-tooltip>
          <tooltip-body class="no-wrap">
            {{ element.created.at | date }}
          </tooltip-body>
          <tooltip-popout>
            Created at {{ element.created.at | date }}
            by
            <app-user [email]="element.created.by"></app-user>
            <br/>
            Last updated at {{ element.updated.at | date }}
            by
            <app-user [email]="element.updated.by"></app-user>
          </tooltip-popout>
        </app-advanced-tooltip>
      </td>
    </ng-container>
    <ng-container matColumnDef="timeSpent">
      <th *matHeaderCellDef mat-header-cell>Hours Spent</th>
      <td *matCellDef="let element" mat-cell>
        {{ element.totalTimeSpentInHours }}
      </td>
    </ng-container>

    <tr *matHeaderRowDef="displayedColumns; sticky: true" mat-header-row></tr>
    <tr (click)="jumpTo(element)" *matRowDef="let element; columns: displayedColumns"
        class="rma-row" mat-row></tr>
    <tr *matNoDataRow class="mat-row">
      <td class="mat-cell no-rma" colspan="4">
        <p>No RMAs found</p>
      </td>
    </tr>

  </table>
</div>
